import React from "react";
import heading from "../../styles/components/Heading.module.scss";

export default function Heading({header, two, three, light, text, center, right}) {

  return (
      <h1 
      className={`
      ${heading.heading}
      ${two && heading["heading--two"]}
      ${three && heading["heading--three"]}
      ${light && heading["heading--light"]}
      ${center && heading["heading--center"]}
      ${right && heading["heading--right"]}`}
      >{header} {text? text : ''}</h1>
  );
}